import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { BankService } from 'src/app/pages/user/profile/services/bank.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { NgIf } from '@angular/common';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { MatButtonModule } from '@angular/material/button';
import { FlexModule } from '@angular/flex-layout/flex';

@Component({
    selector: 'app-notification-banner',
    templateUrl: './notification-banner.component.html',
    standalone: true,
    imports: [FlexModule, MatButtonModule, ExtendedModule, NgIf, MatIconModule, MatProgressSpinnerModule]
})
export class NotificationBannerComponent implements OnInit {
	@Output() publish = new EventEmitter<any>();
	@Input() slug: string = '';
	@Input() isCurrentChildFundraiser: boolean = false;
	@Input() isSave: boolean = false;
	isLoad: boolean = false;
	chargesEnabled!: boolean;
	payoutEnabled!: boolean;
	stripeStatus: any = {};
	detailsSubmitted!: boolean;
	showStripePrompt!: boolean;
	constructor(private _bankService: BankService, private router: Router) {}

	ngOnInit(): void {}
	emitPublishClick() {
		this.isSave = true;
		this.isLoad = true;

		this._bankService.getStripeStatus().subscribe((res: any) => {
			this.stripeStatus = res?.data;
			this.chargesEnabled = this.stripeStatus?.charges_enabled;
			this.payoutEnabled = this.stripeStatus?.payout_enabled;
			this.detailsSubmitted = this.stripeStatus?.details_submitted;
			if (
				this.chargesEnabled === true &&
				this.payoutEnabled === true &&
				this.detailsSubmitted === true
			) {
				this.showStripePrompt = false;
			} else if (
				this.chargesEnabled === false &&
				this.payoutEnabled === false &&
				this.detailsSubmitted === false
			) {
				this.showStripePrompt = false;
			} else if (
				this.chargesEnabled === true &&
				this.payoutEnabled === true &&
				this.detailsSubmitted === true
			) {
				this.showStripePrompt = false;
			} else {
				this.showStripePrompt = true;
			}

			// Route To Publish
			if (this.showStripePrompt == false) {
				this.publish.emit(true);
				// this.isSave = false;
			} else {
				this.router.navigate([
					'fundraising/stripe-prompt',
					{ slug: this.slug },
				]);
				// this.isSave = false;
			}
		});
	}
}
